/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Manual_Qc_Event_Count_BadgeInputs */



/**
* | output |
* | --- |
* | "{count} event(s)" |
*
* @param {Manual_Qc_Event_Count_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_event_count_badge = /** @type {((inputs: Manual_Qc_Event_Count_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Event_Count_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} evenement(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Ereignis(se)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} evento/i`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие(я) ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} evento(s)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 事件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 件のイベント`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} घटना(एँ)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`evento(s) ${i?.count}`)
	return /** @type {LocalizedString} */ (`${i?.count} event(s)`)
});